/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { inject } from "mobx-react";
import { getViewPortHeightWithoutPagesViewScrollbar } from "../../selectors/documentViewSelectors";
import NotificationView from "../../components/NotificationView";
import {
  getNotification,
  getNotificationBanner,
  getNotificationBannerHeight,
  getNotificationHeight,
  getCurrentNotificationBannerHeight,
  getShouldRenderBannerBeforeDoc
} from "../../selectors/notificationSelectors";
import { getShouldUseMobileModernViewer } from "selectors/appSelectors";
import { isFullScreenMode } from "selectors/documentSelectors";

const mapStoreToProps = (stores, ownProps) => {
  const props = {
    ...ownProps,
    viewPortHeight: getViewPortHeightWithoutPagesViewScrollbar(stores),
    notifications: getNotification(stores),
    notificationBanners: getNotificationBanner(stores),
    closeToastNotification: notificationId => stores.notificationViewStore.removeToastNotification(notificationId),
    closeBannerNotification: notificationId => stores.notificationViewStore.removeBannerNotification(notificationId),
    setNotificationHeight: (id, height) => stores.notificationViewStore.setNotificationHeight(id, height),
    getNotificationHeight: id => getNotificationHeight(stores)(id),
    setNotificationBannerHeight: (id, height) => stores.notificationViewStore.setNotificationBannerHeight(id, height),
    getNotificationBannerHeight: id => getNotificationBannerHeight(stores)(id),
    shouldUseMobileModernViewer: getShouldUseMobileModernViewer(stores),
    isFullScreenMode: isFullScreenMode(stores),
    getCurrentNotificationBannerHeight: () => getCurrentNotificationBannerHeight(stores),
    renderBannerBeforeDocView: getShouldRenderBannerBeforeDoc(stores)
  };
  return props;
};

const NotificationViewContainer = inject(mapStoreToProps)(NotificationView);

export default NotificationViewContainer;
